// skipcq: JS-W1028
import { useEffect, useState } from 'react';
import {
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  where,
} from 'firebase/firestore';
import { db } from '../utils/firebase';
import { USER_COHORT_REPORTS_COLLECTION } from '../utils/firestoreCollections';
import { buildUserCohortDailyChartRowsAsc } from '../utils/userCohortDailyChart';

const DAILY_COHORT_REPORT_LOOKBACK_COUNT = 28;

function useUserCohortDailyReports() {
  const [chartRowsAscending, setChartRowsAscending] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const fetchReports = async () => {
      try {
        if (!cancelled) {
          setLoading(true);
          setError(null);
        }

        const reportsCollection = collection(db, USER_COHORT_REPORTS_COLLECTION);
        const reportsQuery = query(
          reportsCollection,
          where('type', '==', 'daily'),
          orderBy('date', 'desc'),
          limit(DAILY_COHORT_REPORT_LOOKBACK_COUNT),
        );
        const snapshot = await getDocs(reportsQuery);
        if (cancelled) {
          return;
        }

        const documents = snapshot.docs.map((documentSnap) => {
          const data = documentSnap.data();
          return {
            id: documentSnap.id,
            date: typeof data.date === 'string' ? data.date : '',
            metrics:
              typeof data.metrics === 'object' && data.metrics !== null ? data.metrics : {},
          };
        });
        setChartRowsAscending(buildUserCohortDailyChartRowsAsc(documents));
      } catch (fetchError) {
        console.error('useUserCohortDailyReports fetch error', fetchError);
        if (!cancelled) {
          setError('Failed to load user cohort reports');
          setChartRowsAscending([]);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    fetchReports();
    return () => {
      cancelled = true;
    };
  }, []);

  return {
    chartRowsAscending,
    loading,
    error,
  };
}

export default useUserCohortDailyReports;
